import {
    Button, Radio, RadioGroup,
    Table, TableBody, TableCell,
    TableCellActions, TableCellLayout,
    TableColumnDefinition,
    TableColumnSizingOptions,
    TableHeader, TableHeaderCell,
    TableRow, Toolbar, ToolbarButton, Tooltip, createTableColumn, makeStyles, shorthands, tokens, useTableColumnSizing_unstable, useTableFeatures
} from "@fluentui/react-components";
import  { ExtendedArchive, Extract } from "../../library/CosmeWidgetAPIClient";
import {
    Delete24Regular, CheckmarkSquare24Regular,
    bundleIcon,
    BoxCheckmark24Filled, BoxCheckmark24Regular,
    BoxSearch24Regular, BoxSearch24Filled,
    Add24Filled, AddRegular,
} from "@fluentui/react-icons";
import { RefObject, createRef, useContext, useEffect, useState } from "react";
import MasterSearchDrawer from "../MasterSearchDrawer";
import ToasterControll from "../../library/ToasterControll";
import { CWClientContext } from "../../App";

// const EditIcon = bundleIcon(EditFilled, EditRegular);

export const MasterCheck = bundleIcon(BoxCheckmark24Filled, BoxCheckmark24Regular,);
export const MasterIcon = bundleIcon(BoxSearch24Filled, BoxSearch24Regular);
const AddIcon = bundleIcon(Add24Filled, AddRegular,);

const useStyles = makeStyles({
    addButton: {
        ...shorthands.borderRadius("6px"),
        ...shorthands.border("1px solid #000000"),
    },
    field: {
        display: "grid",
        gridRowGap: tokens.spacingVerticalS,
    },
    DETECTED: {
        backgroundColor: "#ffffff",
    },
    IGNORE: {
        backgroundColor: "#D0D0D0",
    },
    DONE: {
        backgroundColor: "#D0F0D0",
    },
    CHANGED: {
        backgroundColor: tokens.colorPaletteYellowBackground3,
    },
    editable: {
        width: "100%",
        height: "100%",
    },
    headerCell: {
        textAlign: "center",
        fontWeight: tokens.fontWeightBold,
    },
});

const columnsDef: TableColumnDefinition<Extract>[] = [
    createTableColumn<Extract>({
        columnId: "maker",
        renderHeaderCell: () => <>メーカー名</>,
    }),
    createTableColumn<Extract>({
        columnId: "brand",
        renderHeaderCell: () => <>ブランド名</>,
    }),
    createTableColumn<Extract>({
        columnId: "item",
        renderHeaderCell: () => <>商品名</>,
    }),
    createTableColumn<Extract>({
        columnId: "color",
        renderHeaderCell: () => <>色番</>,
    }),
    createTableColumn<Extract>({
        columnId: "master",
        renderHeaderCell: () => <>元帳</>,
    }),
    createTableColumn<Extract>({
        columnId: "rank",
        renderHeaderCell: () => <>ランク</>,
    }),
    createTableColumn<Extract>({
        columnId: "action",
        renderHeaderCell: () => <>アクション</>,
    }),
];
type ExtractTableProp = {
    extracts: Extract[];
    archive: ExtendedArchive;
}
function ExtractTable(prop: ExtractTableProp):
    JSX.Element {
    const toaster: ToasterControll = new ToasterControll();
    const [columns] = useState<TableColumnDefinition<Extract>[]>(columnsDef);
    const [items, setItems] = useState<Extract[]>(prop.extracts);

    const [columnSizingOptions] =
        useState<TableColumnSizingOptions>({
            maker: {
                idealWidth: 200,
            },
            brand: {
                idealWidth: 200,
            },
            item: {
                idealWidth: 220,
            },
            color: {
                idealWidth: 75,
            }
            ,
            master: {
                idealWidth: 50,
            },
            rank: {
                idealWidth: 120,
            },
            action: {

            },
        });

    const { getRows, columnSizing_unstable, tableRef } = useTableFeatures(
        {
            columns,
            items,
        },
        [useTableColumnSizing_unstable({ columnSizingOptions })]
    );

    const rows = getRows();
    const styles = useStyles();

    const getStyleByStatus = (status: string) => {
        switch (status) {
            case "DETECTED":
                return styles.DETECTED;
            case "IGNORE":
                return styles.IGNORE;
            case "DONE":
                return styles.DONE;
            case "CHANGED":
                return styles.CHANGED;
            default:
                return styles.DETECTED;
        }
    }

    const tableMasterCell = (
        ref: RefObject<HTMLInputElement>,
        extract: Extract, changeValues: (
            maker: string,
            brand: string,
            item: string,
            color: string,
            masterId: string
        ) => void) => {
        if (extract.masterId === null) {
            return (
                <TableCell
                    {...columnSizing_unstable.getTableCellProps("master")}
                >
                    <TableCellLayout
                    >
                        <MasterSearchDrawer
                            extract={extract}
                            tooltipContent={(<>
                                "元帳から探す"
                            </>)}
                            updateCallback={changeValues}
                            buttonIcon={<MasterIcon />}
                        />
                        <input
                            type="hidden"
                            ref={ref}
                            value={
                                    extract.masterId === null ? "" : extract.masterId 
                                }
                        />
                    </TableCellLayout>

                </TableCell>
            )
        } else {
            return (
                <TableCell
                    {...columnSizing_unstable.getTableCellProps("master")}
                >
                    <TableCellLayout
                    >
                        <MasterSearchDrawer
                            extract={extract}
                            tooltipContent={(
                                <>
                                    {extract.masterId} <br />
                                    {extract.maker}/{extract.brand}<br />
                                    {extract.item}/{extract.color}
                                </>
                            )}
                            updateCallback={changeValues}
                            buttonIcon={<MasterCheck />}
                        />
                        <input type="hidden" ref={ref} value={extract.masterId} />
                    </TableCellLayout >
                </TableCell >

            )
        }
    }

    const tableHeader = () => {
        return (
            <TableHeader>
                <TableRow>
                    {columns.map((column) => (
                        <TableHeaderCell
                            className={styles.headerCell}
                            key={column.columnId}
                            {...columnSizing_unstable.getTableHeaderCellProps(column.columnId)}
                        >
                            {column.renderHeaderCell()}
                        </TableHeaderCell>
                    ))}
                </TableRow>
            </TableHeader >
        );
    }

    const tableCell = (label: string, ref: RefObject<HTMLDivElement>, value: string | undefined) => {
        return (
            <TableCell
                {...columnSizing_unstable.getTableCellProps(label)}
            >
                <TableCellLayout
                >
                    <div
                        className={styles.editable}
                        ref={ref}
                    >
                        {value}
                    </div>
                </TableCellLayout>
                <TableCellActions>
                    {/* <Button
                        icon={<EditIcon />}
                        appearance="subtle"
                        aria-label="Edit"
                    /> */}
                </TableCellActions>
            </TableCell>
        );
    }

    const tableRankCell = (ref: RefObject<HTMLInputElement>, value: string | undefined | null) => {
        if (value === null || value === undefined || value === "NONE") {
            value = "C";
        }
        return (
            <TableCell
                {...columnSizing_unstable.getTableCellProps("rank")}
            >
                <TableCellLayout
                >
                    <RadioGroup layout="horizontal-stacked"
                        ref={ref}
                        defaultValue={value}
                    >
                        <Tooltip content="ページ内でこの商品のみが紹介されている。" relationship="label">
                            <Radio value="A" label="A"
                            />
                        </Tooltip>
                        <Tooltip content="ページ内に他の商品もあるが、メインで取り上げられている" relationship="label">
                            <Radio value="B" label="B"
                            />
                        </Tooltip>
                        <Tooltip content="ページ内に存在はするが、メインで取り上げられているのは別の商品" relationship="label">
                            <Radio value="C" label="C"
                            />
                        </Tooltip>
                        <Tooltip content="参照はされているが、記事本文で触れられていない。" relationship="label">
                            <Radio value="D" label="D"
                            />
                        </Tooltip>
                    </RadioGroup>
                </TableCellLayout>
            </TableCell>
        );
    }
    const cwClient = useContext(CWClientContext);

    const ignoreExtract = (id: string, url: string, rowRef: RefObject<HTMLDivElement>) => {
        (async () => {
            cwClient.ignoreExtract(id, url).then((res) => {
                //行のｃlaｓｓName=ignoreにする
                // itemsの該当のExtractのstatusをignoreにする
                console.log(res);
                // toaster.success("無視しました。", "");
                rowRef.current!.className = getStyleByStatus("IGNORE");
            });
        })();
    }
    const fixExtract = (extract: Extract, rowRef: RefObject<HTMLDivElement>) => {
        (async () => {
            items.forEach((item, index) => {
                if (item.id === extract.id) {
                    items[index] = extract;
                    setItems(items);
                }

            });
            cwClient.fixExtract(extract).then((res) => {
                console.log(res);
                // toaster.success("確定しました。", "");
                extract = res.data;
                rowRef.current!.className = getStyleByStatus("DONE");
            });
        })();

    }

    const addRow = () => {
        let extract: Extract = {
            id: "",
            url: prop.archive.archive.url,
            archiveId: prop.archive.archive.id,
            pageTitle: prop.archive.archive.pageTitle,
            status: "DETECTED",
            maker: "",
            brand: "",
            item: "",
            color: "",
            rank: "C",
            masterId: null,
            author: "unknown"
        };
        console.log("addRow : ", rows);
        setItems([...items, extract]);
        console.log("addRow : ", rows);
        if (tableRef !== null) {
            console.log(tableRef);
        }
    }

    useEffect(() => {
        setItems(prop.extracts);
    }, [prop.extracts]);

    

    return (
        <>
            {toaster.tag(
                {
                }
            )}
            <Table sortable ref={tableRef}>
                {tableHeader()}
                <TableBody>
                    {
                        rows.map((row, index) => {
                            let extract = row.item
                            const makerRef = createRef<HTMLDivElement>();
                            const brandRef = createRef<HTMLDivElement>();
                            const itemRef = createRef<HTMLDivElement>();
                            const colorRef = createRef<HTMLDivElement>();
                            const masterRef = createRef<HTMLInputElement>();
                            const rankRef = createRef<HTMLInputElement>();
                            const rowRef = createRef<HTMLDivElement>();

                            const changeValues = (
                                maker: string, brand: string,
                                item: string, color: string,
                                masterId: string
                            ) => {
                                console.log("callback called");
                                console.log(
                                    maker + "/" + brand + "/" + item
                                    + "/" + color + "/" + masterId
                                );
                                makerRef.current!.innerText = maker;
                                brandRef.current!.innerText = brand;
                                itemRef.current!.innerText = item;
                                colorRef.current!.innerText = color;
                                masterRef.current!.value = masterId;
                                extract.masterId = masterId;
                                rows[index].item = extract;
                                rowRef.current!.className = getStyleByStatus("CHANGED");
                            }
                            return (
                                <TableRow key={extract.id} ref={rowRef} className={getStyleByStatus(extract.status)}>
                                    {tableCell("maker", makerRef, extract.maker)}
                                    {tableCell("brand", brandRef, extract.brand)}
                                    {tableCell("item", itemRef, extract.item)}
                                    {tableCell("color", colorRef, extract.color)}
                                    {tableMasterCell(masterRef, extract, changeValues)}
                                    {tableRankCell(rankRef, extract.rank)}
                                    <TableCell>
                                        <TableCellLayout
                                        >
                                            <Button
                                                aria-label="Confirm"
                                                onClick={() => {
                                                    console.log("masterRef.value = ",masterRef.current?.value);
                                                    if (masterRef.current?.value === null
                                                        || masterRef.current?.value === undefined
                                                        || masterRef.current?.value === ""
                                                    ) {
                                                        alert("元帳との紐付けが終わっていません。");
                                                    } else {
                                                        extract.maker = makerRef.current?.innerText;
                                                        extract.brand = brandRef.current?.innerText;
                                                        extract.item = itemRef.current?.innerText;
                                                        extract.color = colorRef.current?.innerText;
                                                        extract.masterId = masterRef.current?.value;
                                                        extract.rank = rankRef.current?.querySelector("input:checked")?.nodeValue;
                                                        fixExtract(extract, rowRef);
                                                    }
                                                }}
                                                icon={<CheckmarkSquare24Regular />} >
                                            </Button>

                                            <Button
                                                aria-label="Delete"
                                                onClick={() => {
                                                    ignoreExtract(extract.id, extract.url, rowRef);
                                                }}
                                                icon={<Delete24Regular />}>
                                            </Button>
                                        </TableCellLayout>
                                    </TableCell>
                                </TableRow>
                            )
                        }
                        )}

                </TableBody >
            </Table >
            <Toolbar>
                <ToolbarButton
                    className={styles.addButton}
                    icon={<AddIcon />}
                    onClick={addRow}
                >
                    追加
                </ToolbarButton>
            </Toolbar>
        </>

    );
}

export default ExtractTable;